const STORAGE_KEY = "consensus-pending-task";
const RAN_KEY = "consensus-pending-task-ran";

function taskFingerprint(task) {
  return `${task.route}|${task.createdAt || 0}|${task.rawPrompt || task.prompt}`;
}

export function setPendingTask(task) {
  sessionStorage.removeItem(RAN_KEY);
  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ ...task, createdAt: Date.now() })
  );
}

export function peekPendingTask(route) {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const task = JSON.parse(raw);
    if (route && task.route !== route) return null;
    return task;
  } catch {
    return null;
  }
}

export function consumePendingTask(route) {
  const task = peekPendingTask(route);
  if (!task) return null;
  if (Date.now() - (task.createdAt || 0) > 5 * 60 * 1000) {
    sessionStorage.removeItem(STORAGE_KEY);
    return null;
  }
  sessionStorage.removeItem(STORAGE_KEY);
  return task;
}

export function markPendingTaskRan(task) {
  try {
    sessionStorage.setItem(RAN_KEY, taskFingerprint(task));
  } catch {
    /* ignore */
  }
}

export function wasPendingTaskRan(task) {
  try {
    return sessionStorage.getItem(RAN_KEY) === taskFingerprint(task);
  } catch {
    return false;
  }
}
